

import { MessageBroadcastStatusEnum, MessageTypeEnum, PriorityEnum } from '@schemax-whatsapp/shared-models';
import { PrimaryGeneratedColumn, Index, Entity, Column, CreateDateColumn, UpdateDateColumn, VersionColumn, Generated } from 'typeorm';

@Entity('blood_donation_user')
export class BloodDonationUser {

    @PrimaryGeneratedColumn('increment', {
        name: 'id'
    })
    id: number;

    @Column("varchar", {
        nullable: false,
        name: "ref_id",
        length:30
    })
    refId: string;

    @Column('varchar', {
        nullable: false,
        name: 'contact',
        length: 30
    })
    contact: string;

    @Column('varchar', {
        nullable: false,
        name: 'username',
        length: 50
    })
    username: string;

    @Column('varchar', {
        nullable: false,
        name: 'constituency',
        length: 100
    })
    constituency: string;

    @Column('tinyint', {
        nullable: false,
        name: 'status',
        default: MessageBroadcastStatusEnum.PENDING
    })
    status: MessageBroadcastStatusEnum;

    @CreateDateColumn({
        name: 'created_at'
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        length: 20,
        name: "created_user"
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at'
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;
}

